<div *ngIf="showSearcher">

  <div class="container d-flex flex-column justify-content-center align-items-center mb-2 mb-sm-3">
    <h2 class="deal-title">
      {{ title | translate | titlecase}}
    </h2>
  </div>

  <div class="d-flex justify-content-center align-items-center pb-5">
    <div class="container  row d-block p-0 px-2 pt-4">
      <div class="col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3">
        <app-search-domains-input (onSearchChangeMode)="onSearchChangeMode()"
                                  (onSingleSearch)="onSingleSearch()" [availableOtherOptions]="false"></app-search-domains-input>
      </div>
    </div>
  </div>

  <!--Search results-->
  <app-search-domain-container *ngIf="showSearcher" [showPricesInSearch]="showPricesInSearch" [onlyTldMx]="onlyTldMx" [buttonAddtoCartText]="buttonAddtoCartText"></app-search-domain-container>
</div>
